define("settings/templates/subscription/billing/payment-method", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-expect-error: Shared::Modal not typesafe yet }}
  <Shared::Modal @close={{perform this.handleClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.subscription.billing.payment_method.title"}} class="u--p__b" />
      {{! @glint-expect-error ModalForm not typesafe yet }}
      <ModalForm
        @cancel={{modal.close}}
        @isDisabled={{this.isSubmitDisabled}}
        @runningText={{t "shared_words.saving"}}
        @task={{this.handleSubmit}}
        as |form|
      >
        <modal.card-body>
          <Payment::StripePaymentElement @isLabelVisible={{false}} @onChange={{this.onPaymentElementChange}} />
        </modal.card-body>
        <modal.card-footer>
          <form.footer @isRunning={{this.isRunning}} @submitButtonText={{t "shared_words.save"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "rkFIXuj9",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0,[\"handleClose\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b\"]],[[\"@title\"],[[28,[37,2],[\"account.subscription.billing.payment_method.title\"],null]]],null],[1,\"\\n\"],[1,\"    \"],[8,[39,3],null,[[\"@cancel\",\"@isDisabled\",\"@runningText\",\"@task\"],[[30,1,[\"close\"]],[30,0,[\"isSubmitDisabled\"]],[28,[37,2],[\"shared_words.saving\"],null],[30,0,[\"handleSubmit\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],null,[[\"@isLabelVisible\",\"@onChange\"],[false,[30,0,[\"onPaymentElementChange\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@isRunning\",\"@submitButtonText\"],[[30,0,[\"isRunning\"]],[28,[37,2],[\"shared_words.save\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"perform\",\"t\",\"modal-form\",\"payment/stripe-payment-element\"]]",
    "moduleName": "settings/templates/subscription/billing/payment-method.hbs",
    "isStrictMode": false
  });
});